export const initialState = {
    user: { user_id: null, userName: null, email: null, admin: null, token: null, created: null },
    doctorList: [],
    stateList: [],
    statusList:[],
    dashboardFilters: { 
        token: '', 
        firstName: '', 
        lastName: '', 
        email: '', 
        phone: '',
        currentFilter: ''
    }
};

const appReducer = (state, action) => {

    switch (action.type) {
        case "ADD_USER":
            return {
                ...state,
                user: action.item,
            };
        case "ADD_DOCTORLIST":
            return {
                ...state,
                doctorList: action.item,
            };
        case "ADD_STATELIST":
            return {
                ...state,
                stateList: action.item,
            };
        case "ADD_STATUSLIST":
            return {
                ...state,
                statusList: action.item,
            };
        case "UPDATE_DASHBOARD_FILTERS":
            return {
                ...state,
                dashboardFilters: action.item,
            };

    default:
            return state;
    }
};

export default appReducer;